import React from "react";
import Loader from "../../../loader/Loader";
import { formatDateToDDMMYYYY } from '../../../utils/dateFormatter';

export default function ConfirmationStep5({
  confirmed,
  loading,
  customerEmail,
  ServiceName,
  ServiceDescription,
  bookingId,
  selectedDate,
  ServicePrice,
  TransactionID
}) {
  const isMeasurementService = ServiceName === "Measurement Service";
  const isFailure = bookingId === "Failure";
  const isBookingExists = bookingId === "Booking Exists";

  const handleRedirect = () => {
    if (isMeasurementService) {
      window.location.href = "/app/index.html?skey=planning";
    } else {
      window.location.href = "/app/index.html";
    }
  };

  if (loading) {
    return (
      <div className="step-5 confirmation-card">
        <Loader />
      </div>
    );
  }

  if (!confirmed) return null;

  if (isFailure) {
    return (
      <div className="step-5 confirmation-card">
        <div className="confirmation-card-body">
          <div className="confirmation-message failure-message">
            <h4>Payment Failed</h4>
            <p>
              Please try again or contact our support team for assistance.
            </p>
          </div>
          <div className="confirmation-footer">
            <button className="cta-button" onClick={() => window.location.href = "/app/index.html"}>
              Go to Homepage
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (isBookingExists) {
    return (
      <div className="step-5 confirmation-card">
        <div className="confirmation-card-body">
          <div className="confirmation-message failure-message">
            <h4>Booking Already Exists</h4>
            <p>
              You've already created a booking for this service.
              Please check your <strong>email</strong> or <strong>SMS</strong> for your booking details.
            </p>
          </div>
          <div className="confirmation-footer">
            <button className="cta-button" onClick={() => window.location.href = "/app/index.html"}>
              Go to Homepage
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="step-5 confirmation-card">
      <div className="confirmation-card-body">
        <div className="confirmation-message">
          <h4>Booking Confirmed!</h4>
          <p>
            Thank you for choosing us. The order confirmation has been sent to{" "}
            <strong>{customerEmail || "No Email"}</strong>
          </p>
        </div>

        <div className="confirmation-details">
          <div className="service-info">
            <div>
              <h3 className="strongtitle">{ServiceName}</h3>
              <p>{ServiceDescription}</p>
            </div>
          </div>

          <ul className="booking-more-info">
            <li>
              <span>Booking ID</span>
              <h4>{bookingId || "-"}</h4>
            </li>
            <li>
              <span>Request Type</span>
              <h4>{ServiceName}</h4>
            </li>
            <li>
              <span>Appointment Date</span>
              <h4>{formatDateToDDMMYYYY(selectedDate)}</h4>
            </li>
            <li>
              <span>Paid Amount</span>
              <h4>
                <span className="price">
                  <span className="currency-sup">Dhs</span>
                  {ServicePrice?.toString()?.includes(".") ? (
                    <>
                      {ServicePrice.toString().split(".")[0]}
                      <span className="decimal-sub">
                        .{ServicePrice.toString().split(".")[1]}
                      </span>
                    </>
                  ) : (
                    ServicePrice
                  )}
                </span>
              </h4>
            </li>
            <li>
              <span>Transaction ID</span>
              <h4>{TransactionID}</h4>
            </li>
          </ul>
        </div>

        <div className="confirmation-footer">
          {isMeasurementService && (
            <p className="next-step-message">
              Want to continue your journey? Book a Planning service next.
            </p>
          )}

          <button className="cta-button" onClick={handleRedirect}>
            {isMeasurementService ? "Book Planning" : "Go to Homepage"}
          </button>
        </div>
      </div>
    </div>
  );
}
